import Vue from 'vue'
import Router from 'vue-router'
import { getWhiteList } from '@/utils/auth'
import authPages from './authPages'

const Layout = authPages.Layout

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
const constantRouteMap = [
  // { path: '/hidden-index', component: () => import('@/views/Dashboard'), hidden: true },
  // { path: '/index', component: () => import('@/views/Game'), hidden: true },
  { path: '/index', component: () => import('@/views/Dashboard'), hidden: true },
  { path: '/list', component: () => import('@/views/Game'), hidden: true },
  { path: '/game', component: () => import('@/views/More'), hidden: true },
  { path: '/guide', component: () => import('@/views/More'), hidden: true },
  { path: '/article', component: () => import('@/views/More'), hidden: true },
  { path: '/event', component: () => import('@/views/More'), hidden: true },
  { path: '/more', component: () => import('@/views/More'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '/101', component: () => import('@/views/404'), hidden: true },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [{
      path: '/redirect/:path*',
      component: () => import('@/views/Redirect'),
    }],
  },
  {
    path: '/',
    redirect: '/dashboard',
    hidden: true,
  },
  { path: '*', redirect: '/404', hidden: true },
]

// 实例化路由
const createRouter = () => new Router({
  base: '/pages/',
  mode: 'history', // 后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouteMap,
})

const router = createRouter()

const resetRouter = () => {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

// 生成路由白名单
const routerWhiteList = getWhiteList(constantRouteMap)

export {
  constantRouteMap,
  routerWhiteList,
  resetRouter,
}

export default router
